import React, { Fragment, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Link, useParams, useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';
import Spinner from '../layout/Spinner';
import { getLicenseById, deleteLicense } from '../../actions/license';
import Moment from 'react-moment';
import moment from 'moment';
import { FaTrashAlt } from 'react-icons/fa';
import { AiOutlineEdit } from 'react-icons/ai';
import { AiOutlineArrowLeft } from 'react-icons/ai';
import { useTranslation, Trans } from 'react-i18next';

const LicenseDetail = ({
  getLicenseById,
  deleteLicense,
  license: { license, loading },
  auth
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [action, setaction] = useState(false);
  const { id } = useParams();

  const DeleteLicense = () => {
    setaction(true);
    deleteLicense(license ? license._id : id);
    setTimeout(() => {
      navigate('/licenses');
    }, 1000);
  };

  useEffect(() => {
    getLicenseById(id);
  }, [getLicenseById, id]);

  return (
    <section className="container">
      <Fragment>
        {license === null || loading || action ? (
          <Spinner />
        ) : (
          <Fragment>
            <div className="row">
              <div className="col-auto">
                <Link
                  to="/licenses"
                  className="btn btn-dark"
                  style={{
                    marginBottom: '1rem'
                  }}
                >
                  <AiOutlineArrowLeft /> {t('back_license_list')}
                </Link>
              </div>

              <div className="col-auto">
                <Link
                  to={`/edit-license/${license ? license._id : id}`}
                  className="btn btn-dark"
                  style={{
                    marginBottom: '1rem'
                  }}
                >
                  {t('modify_license')}
                  <AiOutlineEdit />
                </Link>
              </div>
              {auth.isAuthenticated &&
                auth.loading === false &&
                (auth.user.rights === 'admin' ||
                  auth.user.rights === 'ADV') && (
                  <div className="col-auto">
                    <button
                      className="btn btn-danger btn-lg"
                      style={{
                        marginBottom: '1rem'
                      }}
                      onClick={() => DeleteLicense()}
                    >
                      {t('delete_license')} <FaTrashAlt />
                    </button>
                  </div>
                )}
            </div>
            {license.status === 'disabled' ? (
              <h4 className="bg-warning my-2 p-2 text-center">
                {t('license_deactivated')}
              </h4>
            ) : license.status === 'expired' ? (
              <h4 className="bg-warning my-2 p-2 text-center">
                {t('license_expired')}
              </h4>
            ) : license.status === 'finished' ? (
              <h4 className="bg-warning my-2 p-2 text-center">
                {t('license_finished')}
              </h4>
            ) : (
              <div></div>
            )}
            <div className="profile-grid my-1">
              <div className={'profile-top bg-primary p-2'}>
                {/* <img className="round-img my-4" src={avatar} alt="" /> */}
                <p className="lead">
                  {license.licenseId && (
                    <span>
                      {t('licenseId')} : {license.licenseId}
                    </span>
                  )}
                </p>
                <p className="lead">
                  {license.type && (
                    <span>
                      {t('type_hint')} : {license.type}
                    </span>
                  )}
                </p>
                <p className="lead">
                  {license.entity && (
                    <span>
                      {t('entity')} : {license.entity}
                    </span>
                  )}
                </p>
                <p className="lead">
                  {license.startDate && (
                    <span>
                      {t('startDate')} :
                      <Moment format=" DD/MM/YYYY">
                        {moment(license.startDate).local()}
                      </Moment>
                    </span>
                  )}
                </p>
                <p className="lead">
                  {license.endDate && (
                    <span>
                      {t('endDate')} :
                      <Moment format=" DD/MM/YYYY">
                        {moment(license.endDate).local()}
                      </Moment>
                    </span>
                  )}
                </p>
                <p className="lead">
                  {license.status && (
                    <span>
                      {t('state')} :{' '}
                      {license.status === 'activated' ? (
                        <Trans>{t('activated')}</Trans>
                      ) : license.status === 'disabled' ? (
                        <Trans>{t('deactivated')}</Trans>
                      ) : license.status === 'finished' ? (
                        <Trans>{t('finished')}</Trans>
                      ) : license.status === 'expired' ? (
                        <Trans>{t('expired')}</Trans>
                      ) : (
                        <Trans>{t('deactivated')}</Trans>
                      )}
                    </span>
                  )}
                </p>
                <p className="lead">
                  {license.descriptionADV && (
                    <span>
                      {t('descriptionADV')} : {license.descriptionADV}
                    </span>
                  )}
                </p>
                <p className="lead">
                  {license.descriptionAdminEntity && (
                    <span>
                      {auth.user.rights === 'admin' ||
                      auth.user.rights === 'ADV'
                        ? t('descriptionAdminEntity')
                        : t('descriptionAdminEntity_viewcustomer')}
                      :{license.descriptionAdminEntity}
                    </span>
                  )}
                </p>
              </div>
            </div>
          </Fragment>
        )}
      </Fragment>
    </section>
  );
};

LicenseDetail.propTypes = {
  getLicenseById: PropTypes.func.isRequired,
  deleteLicense: PropTypes.func.isRequired,
  license: PropTypes.object.isRequired,
  auth: PropTypes.object.isRequired
};

const mapStateToProps = (state) => ({
  license: state.license,
  auth: state.auth
});

export default connect(mapStateToProps, {
  getLicenseById,
  deleteLicense
})(LicenseDetail);
